class $318698953f918506$export$846a832cf85607c2 {
    constructor(canvas, vanishingPoint, options = {}){
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.vp = vanishingPoint;
        this.numVertical = options.numVertical || 12;
        this.lineColor = options.lineColor || "#222";
        this.lineWidth = options.lineWidth || 1;
        this.groundSpacing = options.groundSpacing || 120; // <-- increase for more space!
        this.perspectiveExponent = options.perspectiveExponent || 1.6; // tweak for more/less compression
        this.perspectiveSpread = options.perspectiveSpread || 40; // tweak for how far lines go visually
    }
    draw(scrollDepth = 0) {
        const w = this.canvas.width;
        const h = this.canvas.height;
        const vp = this.vp.position;
        this.ctx.clearRect(0, 0, w, h);
        // Vertical lines: radiate from vanishing point to bottom edge
        for(let i = 0; i <= this.numVertical; i++){
            const x = i / this.numVertical * w;
            this.ctx.save();
            this.ctx.strokeStyle = this.lineColor;
            this.ctx.lineWidth = this.lineWidth;
            this.ctx.beginPath();
            this.ctx.moveTo(vp.x, vp.y);
            this.ctx.lineTo(x, h);
            this.ctx.stroke();
            this.ctx.restore();
        }
        // Horizontal lines: infinite ground illusion
        let lineIndex = 1;
        while(true){
            // The t value determines spacing: lineIndex + scrollDepth/groundSpacing.
            // Increase groundSpacing for wider gaps.
            const t = (lineIndex + scrollDepth / this.groundSpacing) / this.perspectiveSpread;
            const y = vp.y + (h - vp.y) * Math.pow(t, this.perspectiveExponent);
            if (y > h) break; // Stop when offscreen
            if (y > vp.y) {
                this.ctx.save();
                this.ctx.strokeStyle = this.lineColor;
                this.ctx.lineWidth = this.lineWidth;
                this.ctx.beginPath();
                this.ctx.moveTo(0, y);
                this.ctx.lineTo(w, y);
                this.ctx.stroke();
                this.ctx.restore();
            }
            lineIndex++;
        }
    }
}


class $65edc23890b2ef7b$export$234da051ab136278 {
    constructor(canvas){
        this.canvas = canvas;
        this.update();
    }
    update() {
        this.x = this.canvas.width / 2;
        this.y = this.canvas.height / 2;
    }
    draw() {
    // Optionally draw on canvas, but you also have the #vanishingPoint div for reference
    // The dot is handled by the HTML/CSS
    }
    get position() {
        return {
            x: this.x,
            y: this.y
        };
    }
}


class $88c0cba2e6f07cee$export$875c32db6f1809cc {
    constructor(element, vanishingPoint, anchorScroll = 0){
        this.el = element;
        this.vp = vanishingPoint;
        this.anchorScroll = anchorScroll; // When this paragraph starts animating
    }
    update(scrollDepth = 0) {
        // Use scrollDepth relative to anchorScroll
        const relativeScroll = scrollDepth - this.anchorScroll;
        let scale = Math.exp(relativeScroll / 1000); // Can tweak this
        this.el.style.left = `${this.vp.x}px`;
        this.el.style.top = `${this.vp.y}px`;
        this.el.style.transform = `scale(${scale})`;
        this.el.style.transformOrigin = `left top`;
        this.el.style.display = scale < 0.01 || scale > 200 ? "none" : "block";
    }
}


function $efd3ba4ec2608b1d$var$setup() {
    document.body.style.height = "10000px";
    const canvas = document.getElementById('perspectiveGrid');
    const vanishingPointObj = new (0, $65edc23890b2ef7b$export$234da051ab136278)(canvas);
    const grid = new (0, $318698953f918506$export$846a832cf85607c2)(canvas, vanishingPointObj, {
        numVertical: 12,
        groundSpacing: 500,
        perspectiveExponent: 1.6,
        perspectiveSpread: 20,
        lineColor: "#222",
        lineWidth: 1
    });
    // Dynamic paragraphs
    const paragraphContents = [
        "capitale culturelle 2027\nla chaux-de-fonds",
        "second dynamic paragraph\nthat follows the first",
        "third paragraph with even more spacing"
    ];
    const paragraphs = [];
    paragraphContents.forEach((content, idx)=>{
        const el = document.createElement("div");
        el.className = "perspective-paragraph";
        el.innerHTML = content;
        document.body.appendChild(el);
        // Spacing of 2000px between each paragraph
        const anchorScroll = 3000 * idx;
        paragraphs.push(new (0, $88c0cba2e6f07cee$export$875c32db6f1809cc)(el, vanishingPointObj, anchorScroll));
    });
    function resize() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        vanishingPointObj.update();
        updateScene(window.scrollY);
    }
    function updateScene(scrollDepth) {
        grid.draw(scrollDepth);
        paragraphs.forEach((p)=>p.update(scrollDepth));
    }
    window.addEventListener('resize', resize);
    window.addEventListener('scroll', ()=>updateScene(window.scrollY));
    resize();
}
window.onload = $efd3ba4ec2608b1d$var$setup;


//# sourceMappingURL=path0.6a09ee15.js.map
